export const SETTINGS_TABS = ["account", "payments", "notifications"];

export const getSettingsTabFromSearch = (search) => {
  const tab = new URLSearchParams(search || "").get("tab");
  return SETTINGS_TABS.includes(tab) ? tab : null;
};
